import actions from './index';
import { BASE_URL } from '../constants/api';

export const ACTIONS = {
  GET: 'ACTIVITY_AGGREGATION_GET',
  GET_SUCCESS: 'ACTIVITY_AGGREGATION_GET_SUCCESS',
  GET_FAILURE: 'ACTIVITY_AGGREGATION_GET_FAILURE',
  INVALIDATE_ITEM: 'ACTIVITY_AGGREGATION_INVALIDATE_ITEM',
  GET_ALL: 'ACTIVITY_AGGREGATION_GET_ALL',
  GET_ALL_SUCCESS: 'ACTIVITY_AGGREGATION_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ACTIVITY_AGGREGATION_GET_ALL_FAILURE',
};

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(() => `${BASE_URL}/intelanalytics/activity-list/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
